<div class="bg-secondary">
    <main>
        <div class="container">
            <p>&nbsp;</p>
            <user-signon-chart></user-signon-chart>
            <p>&nbsp;</p>
            <!--Grid row-->
            <div class="row1">
                <b-card>
                    <b-form-group label="Econet USD">
                        <b-form-input v-model="econet" disabled></b-form-input>
                    </b-form-group>
                    <b-form-group label="Airtime">
                        <b-form-input v-model="airtime" disabled></b-form-input>
                    </b-form-group>
                    <b-form-group label="zesa">
                        <b-form-input v-model="zesa" disabled></b-form-input>
                    </b-form-group>
                    <b-form-group label="SA">
                        <b-form-input v-model="sa" disabled></b-form-input>
                    </b-form-group>
                    <b-form-group label="Airtel">
                        <b-form-input v-model="airtel" disabled></b-form-input>
                    </b-form-group>
                    <b-form-group label="TNM">
                        <b-form-input v-model="tnm" disabled></b-form-input>
                    </b-form-group>
                </b-card>
            </div>
            <!--Grid row-->
            <b-overlay :show="busy" no-wrap >
                <template #overlay>
                    <div v-if="processing" class="text-center p-4 bg-primary text-light rounded">
                      <b-icon icon="cloud" font-scale="4"></b-icon>
                      <div class="mb-3">Processing...</div>
                      <div class="text-center">
                        <b-spinner type="grow" label="Spinning"></b-spinner>
                      </div>
                    </div>
                    <div
                      v-else
                      ref="dialog"
                      tabindex="-1"
                      role="dialog"
                      aria-modal="false"
                      aria-labelledby="form-confirm-label"
                      class="text-center p-3"
                    >
                      <p><strong id="form-confirm-label">Are you sure, you want to do a deposit?</strong></p>
                      <div class="d-flex">
                        <b-button variant="outline-danger" class="mr-3" @click="onCancel">
                          Cancel
                        </b-button>
                        <b-button variant="outline-success" @click="onOK">OK</b-button>
                      </div>
                    </div>
                  </template>
              </b-overlay>
            <p>&nbsp;</p>
        </div>
    </main>
    <!--Main layout-->
</div>